import { apiFetch } from '@nrdy-marketing-engine/api-fetch';
import {
  UserSubscription,
  UserSubscriptionResponse,
} from '@nrdy-marketing-engine/cart/@types/user-subscription';
import useSWR from 'swr';

interface UserSubscriptionReturnInterface {
  fetchError: Error | string | null;
  loading: boolean;
  refetch: () => void;
  userSubscriptions: UserSubscription[] | null;
}

const useUserSubscriptionData = (userId?: string): UserSubscriptionReturnInterface => {
  const fetchPath = userId ? `/v1/users/${userId}/subscriptions` : null;

  const {
    data: userSubscriptionsData,
    error: fetchError,
    isLoading: loading,
    mutate: refetch,
  } = useSWR<{ data: UserSubscriptionResponse }>(fetchPath, apiFetch);

  const { data: userSubscriptions } = userSubscriptionsData || { data: null };

  return { userSubscriptions, refetch, fetchError, loading };
};

export default useUserSubscriptionData;
